import "./settings/settings_navigation_item.js";

class SettingsNavigation {
  constructor(navbarSelector, contentSelector) {
    this.activeNavigationItem = "";
    this.navbar = document.getElementById(navbarSelector);
    this.navbarWrapperEl = this.navbar.querySelector(".settings-nav-wrapper");
    this.content = document.getElementById(contentSelector);
    this.hotkeyBinding = {
      up: {
        hint: "j",
        class: "up",
        icon: "arrow-up",
      },
      down: {
        hint: "k",
        class: "down",
        icon: "arrow-down",
      },
    };

    this._setupNavItems();
    this._setHotkeyWrapperEl();
    this._setupHotkeyButtons();
    this._changeActiveNav();
    this._initializeNavigation();
    this._setupEventListeners();
  }

  _setNavBarMinHeight() {
    const { navbarWrapperEl, hotkeyWrapperEl } = this;
    if (navbarWrapperEl && hotkeyWrapperEl) {
      this.navBarMinHeight = navbarWrapperEl.offsetHeight + hotkeyWrapperEl.offsetHeight;
    }
  }
  // BEHAVIOUR

  _setupNavItems() {
    let navItems = this.navbar.querySelectorAll(".settings-nav-item");
    navItems.forEach((node) => {
      node.navOptions = new SettingsNavigationItem(node);
    });
  }

  // Watches the onpopstate event
  _observeURLState() {
    window.addEventListener("popstate", this._render.bind(this));
  }
  // Register Listner / Observers
  _setupEventListeners() {
    this._observeURLState();
    this._observeResizeNavbar();

    this.navbar.querySelector(".settings-nav-wrapper").addEventListener("click", (event) => {
      this._navigateTo(event.target);
    });

    this.navbar.querySelector(".hotkey-up").addEventListener("click", () => {
      this._prevNavItem();
    });

    this.navbar.querySelector(".hotkey-down").addEventListener("click", () => {
      this._nextNavItem();
    });

    document.addEventListener("keyup", (event) => {
      this._setupKeyBinding(event);
    });

    jQuery('[id^="definition_list_form"]').on("input:validation", (e, input, valid, wasInvalid) => {
      this._changeNotificationOnInputValidity(input, valid, wasInvalid);
    });
  }

  // EVENT HANDLERS
  _handleResizeNavbar(entry) {
    const { navbar, navBarMinHeight } = this;
    const { height } = entry.contentRect;

    if (navBarMinHeight) {
      navbar.classList.toggle("--fixed-hotkeys", height < navBarMinHeight);
    }
  }
  // Keybinding
  _setupKeyBinding(event) {
    // ctrl + j
    if (event.ctrlKey && event.which === 74) {
      this._prevNavItem();
    }
    // ctrl + k
    if (event.ctrlKey && event.which === 75) {
      this._nextNavItem();
    }
  }

  // HELPER FUNCTIONS

  // Sets up initial navigation of settings form
  // If there is a url param for the setting item navigate to it
  // If not go to the top of the page and show the notice-coach if there is one.
  _initializeNavigation() {
    const settingItem = this._getURLState();
    if (settingItem) {
      this._navigateTo(settingItem);
    } else {
      this._navigateTo(this.navbar.querySelector("[data-settings-id]"));
    }
  }

  _observeResizeNavbar() {
    this._setNavBarMinHeight();
    const ro = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this._handleResizeNavbar(entry);
      }
    });
    ro.observe(this.navbar);
  }

  _changeNotificationOnInputValidity(input, valid, wasInvalid) {
    const settingsItem = this._findSettingItemByElement(input);
    if (settingsItem) {
      if (valid && wasInvalid) {
        settingsItem.navOptions.decrementNotification();
      } else if (!valid && !wasInvalid) {
        settingsItem.navOptions.incrementNotification();
      }
    }
  }

  // Navigation Items
  // Context is passed to the html element.
  _navigateTo(target) {
    if (!target) {
      return;
    }

    const navItem = target.closest("[data-settings-id]");
    if (navItem) {
      const id = navItem.dataset.settingsId;
      this._changeActiveNav(navItem);
      this._setURLState(id);
      this._render();
    }
  }

  _changeActiveNav(navItem) {
    this.activeNavigationItem = navItem;
  }

  _activateSetting(navItem) {
    const prevActiveNavItem = this.navbar.querySelector("[data-settings-id].active");
    if (prevActiveNavItem) {
      prevActiveNavItem.classList.remove("active");
      this.content.querySelector("fieldset.active").classList.remove("active");
    }
    this._contentFromNavItem(navItem).classList.add("active");
    navItem.classList.add("active");
    this.content.scrollTop = 0;
  }

  _contentFromNavItem(navItem) {
    return this.content.querySelector("#" + navItem.dataset.settingsId);
  }

  _render() {
    this._activateSetting(this._getURLState());
    Form.decorate(this._contentFromNavItem(this.activeNavigationItem)); // Makes Selects that were hidden rerender
    Form.updateReturnTo();
  }

  _getURLState() {
    const url = new URL(window.location.href);
    return this._findSettingItemById(url.searchParams.get("settingItem"));
  }

  _setURLState(settingsId) {
    this.url = new URL(window.location.href);
    this.url.searchParams.set("settingItem", settingsId);
    history.replaceState("", "", this.url.toString());
  }

  _nextNavItem() {
    const navItem = jQuery(this.activeNavigationItem).nextAll(".settings-nav-item:not(.hidden)")[0];
    if (navItem) {
      this._navigateTo(navItem);
    }
  }

  _prevNavItem() {
    const navItem = jQuery(this.activeNavigationItem).prevAll(".settings-nav-item:not(.hidden)")[0];
    if (navItem) {
      this._navigateTo(navItem);
    }
  }

  // Notifications
  setNotifications(id, number) {
    if (this._findSettingItemById(id) == null) {
      return false;
    }
    this._findSettingItemById(id).navOptions.setNotifications(number);
  }

  // Create Hotkey buttons
  _setHotkeyWrapperEl() {
    const wrapperEl = document.createElement("div");
    wrapperEl.classList.add("settings-nav-hotkey-wrapper");
    this.hotkeyWrapperEl = wrapperEl;
  }

  _setupHotkeyButtons() {
    const { hotkeyBinding, hotkeyWrapperEl } = this;

    for (var key in hotkeyBinding) {
      let hotkey = this._createHotkey(hotkeyBinding[key]);
      hotkeyWrapperEl.appendChild(hotkey[0]);
    }

    this.navbar.appendChild(hotkeyWrapperEl);
  }

  _createHotkey(hotkeyObj) {
    const hotkey = jQuery(
      `<div data-tooltip="ctrl + ${hotkeyObj.hint}" data-tooltip-position="top" class="hotkey hotkey-${hotkeyObj.class}"></div>`,
    );

    hotkey.append(createIconTag(hotkeyObj.icon));

    return hotkey;
  }

  _findSettingItemByElement(element) {
    return this._findSettingItemById(element.closest(".settings__fieldset").getAttribute("id"));
  }

  _findSettingItemById(id) {
    return this.navbar.querySelector("[data-settings-id=" + id + "]");
  }
}

window.SettingsNavigation = SettingsNavigation;
